export const EMPTY_ALLOW_CREDENTIALS_ERROR = 'No credentials are present in "allowCredentials"'
export const NULL_ALLOW_CREDENTIALS_ERROR = '"allowCredentials" is null'
export const NO_VALID_CREDENTIALS_ERROR = 'Allowed credentials do not match valid credentials'

export const SILENT_BIOMETRIC_ERROR_MESSAGES = [EMPTY_ALLOW_CREDENTIALS_ERROR, NULL_ALLOW_CREDENTIALS_ERROR, NO_VALID_CREDENTIALS_ERROR]
